import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Loader from "../../../../components/sprite/components/loader/index";
import Avatar from "../../../../components/avatar/index";
import {NavLink} from "react-router-dom";
import Icon from "../../../../components/icon/index";
import {toLocalDateTimeWithoutSeconds} from '../../../../utils/index';
import {sharingPageReady} from '../../../../../actions/profileActions';
import {
	fetchContactsHistoryLogs,
	fetchNextContactsHistoryLogs,
	loadNextContactsHistory as setLoadNextContactsHistory
} from '../../../../../actions/contactsHistoryLogsActions';
import './index.css';
import Button from '../../../../components/button';

function ContactsHistoryLogs() {

	const [isRefreshing, setIsRefreshing] = useState(false);

	const contactsHistoryLogsRef = useRef(null);

    const dispatch = useDispatch();

    const contactsHistoryLogs = useSelector((state) => state.contactsHistoryLogsReducer.contactsHistoryLogs);
    const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
    const loadNextContactsHistory = useSelector(state => state.contactsHistoryLogsReducer.loadNextContactsHistory);

    const { t } = useTranslation();

    useEffect(() => {
	    dispatch(sharingPageReady(true));
	    if(!contactsHistoryLogs){
		    dispatch(fetchContactsHistoryLogs());
        }
    }, [dispatch, contactsHistoryLogs]);

	useEffect(() => {
		if(loadNextContactsHistory){
		    dispatch(fetchNextContactsHistoryLogs(2));
		}
	}, [dispatch, loadNextContactsHistory]);

	const update = () => {
		if(contactsHistoryLogsRef.current.scrollTop > (contactsHistoryLogsRef.current.scrollHeight - contactsHistoryLogsRef.current.clientHeight) / 2) {
		    //dispatch(fetchNextContactsHistoryLogs(2));
			if(!loadNextContactsHistory){
				dispatch(setLoadNextContactsHistory(true));
			}
		}
	};

	const handleRefresh = () => {
		contactsHistoryLogsRef.current.scrollTop = 0;
		dispatch(setLoadNextContactsHistory(false));
		setIsRefreshing(true);
	    dispatch(fetchContactsHistoryLogs());
	    setTimeout(() => {
		    setIsRefreshing(false);
	    }, 1000);
    };

	const SOURCE_LABELS = {
		WEBAPP: 'from Webapp',

		IPAD_APP: 'from Google Contacts',
		IPHONE_APP: 'from Google Contacts',
		ANDROID_APP: 'from Google Contacts',

		GOOGLE_CONTACTS: 'from Google Contacts',

		MOBILE_APP: 'from Mobile',

		DOCS_ADDON: 'from Docs Add-on',
		DRIVE_ADDON: 'from Drive Add-on',
		GMAIL_ADDON: 'from Gmail Add-on',
		CALENDAR_ADDON: 'from Calendar Add-on',

		CHROME_EXTENSION: 'from Chrome Extension',

		THIRD_PARTY_APP: 'from Third-party app',
		THIRD_PARTY_ZAPIER: 'from Zapier',
		THIRD_PARTY_UNKNOWN: 'from Third-party app',

		UNKNOWN: null,
	};

	const FEATURE_LABELS = {
		'From Application Interface' : 'by the contact form',
		'From Recording' : 'by the contact form',
		'Created Using Directory Feature' : 'created using Directory feature'
	};

    return (
        <div className="contacts-history-logs">
            <div className="contacts-history-logs__header">
				<div className="d-flex align-items-center">
					<h2 className="m-0">{t('contactsHistoryLogsTitle')}</h2>
					{
						contactsHistoryLogs && contactsHistoryLogs.logs.length > 0
						&& <Button onClick={handleRefresh} className="btn-link pl-2 p-0">
							<Icon animated={isRefreshing ? 'spin' : null} name="refresh"/>
						</Button>
					}
				</div>
				{
					selectedContactsGroup && <div>
						<NavLink
							to={`/label/${selectedContactsGroup.id === '6' ? selectedContactsGroup.id + '-' + selectedContactsGroup.ownerId : selectedContactsGroup.id}`}
							className="btn-link pr-2"
                        >
                            <Icon name="long-arrow-left" className="mr-2"/> {t("getBackText")}
                        </NavLink>
                    </div>
                }
            </div>
            {/*
                <div className="contacts-history-logs__options">
                    <div className="col-2">
                        <Input type="text"/>
                    </div>
                    <div className="col-2">
                        <Select>
                            <option value="">Test</option>
                        </Select>
                    </div>
                    <div className="col-2">
                        <Select>
                            <option value="">Test</option>
                        </Select>
                    </div>
                    <div className="col-2">
                        <Select>
                            <option value="">Test</option>
                        </Select>
                    </div>
                    <div className="col-2">
                        <Select>
                            <option value="">Test</option>
                        </Select>
                    </div>
                    <div className="col-2">
                        <Select>
                            <option value="">Test</option>
                        </Select>
                    </div>
                </div>
            */}
            <div className="contacts-history-logs_content" ref={ contactsHistoryLogsRef } onScroll={ update }>
                {
                    contactsHistoryLogs !== null
                    ?
                        contactsHistoryLogs.logs.length > 0
                        ?
                            contactsHistoryLogs.logs.map(item => {

	                            const sourceLabel = item.source && SOURCE_LABELS[item.source];
	                            const featureLabel = item.feature && FEATURE_LABELS[item.feature];

                            	return (
		                            <NavLink key={item.id} to={`/contact/${item.contactId}`} className="contacts-history-logs_content__row">
	                                    <div className="d-flex">
	                                        <Avatar className="mr-2" size={'4em'} src={item.picture}/>
	                                        <div>
	                                            <p className="m-0">
	                                                {
	                                                    item.changeType === "CONTACT_CREATED" &&
	                                                    !item.source && !item.feature
	                                                        ?
	                                                        <small>Contact created:&nbsp;</small>
	                                                        :
	                                                        <small>Contact created</small>
	                                                }
		                                            {sourceLabel && (
		                                                <>
				                                            {' '}
				                                            <small className="item-source">
					                                            {sourceLabel}
				                                            </small>
			                                            </>
		                                            )}
		                                            {
			                                            featureLabel && (
				                                            <>
					                                            {', '}
					                                            <small className="item-feature">
						                                            {featureLabel}
					                                            </small>
				                                            </>
			                                            )
		                                            }
	                                                {
	                                                    item.currentContactEntry && item.currentContactEntry.aiContact &&
	                                                    <svg
	                                                        xmlns="http://www.w3.org/2000/svg"
	                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
	                                                        x="0px"
	                                                        y="0px"
	                                                        width="15px"
	                                                        height="15px"
	                                                        viewBox="0 0 20 20"
	                                                        enableBackground="new 0 0 20 20"
	                                                        xmlSpace="preserve"
	                                                        className="ml-1"
	                                                    >
	                                                        <path
	                                                            fill="#ea6"
	                                                            d="M20,10c-8.571,0.789-9.211,1.429-10,10c-0.789-8.571-1.429-9.211-10-10C8.571,9.211,9.211,8.571,10,0 C10.789,8.571,11.429,9.211,20,10z"/>
	                                                        <path
	                                                            fill="#ea6"
	                                                            d="M20,3.5C17,3.776,16.776,4,16.5,7C16.224,4,16,3.776,13,3.5C16,3.224,16.224,3,16.5,0C16.776,3,17,3.224,20,3.5z"/>
	                                                        <path
	                                                            fill="#ea6"
	                                                            d="M0,16.5C3,16.224,3.224,16,3.5,13C3.776,16,4,16.224,7,16.5C4,16.776,3.776,17,3.5,20C3.224,17,3,16.776,0,16.5z"/>
	                                                    </svg>
	                                                }
	                                            </p>
	                                            {
	                                                item.currentContactEntry &&
	                                                <p className="lead m-0">
	                                                    {
	                                                        [
	                                                            item.currentContactEntry.givenName,
	                                                            item.currentContactEntry.middleName,
	                                                            item.currentContactEntry.familyName
	                                                        ].filter(Boolean).join(' ')
	                                                    }
	                                                    {
	                                                        item.currentContactEntry.jobTitle && (
	                                                            <>
	                                                                , <span style={{color: '#999'}}>
	                                                            {item.currentContactEntry.jobTitle}
	                                                        </span>
	                                                            </>
	                                                        )
	                                                    }
	                                                    {
	                                                        item.currentContactEntry.company && (
	                                                            <>
	                                                                , at <span>
	                                                            {item.currentContactEntry.company}
	                                                        </span>
	                                                            </>
	                                                        )
	                                                    }
	                                                </p>
	                                            }
	                                            {
	                                                item.changeType === "CONTACT_CREATED" &&
	                                                <p className="m-0"><small>Created by {item.actionBy.name}</small></p>
	                                            }
	                                        </div>
	                                        <div className="ml-auto float-right">
	                                            {toLocalDateTimeWithoutSeconds(item.createdAt)}
	                                        </div>
	                                    </div>
	                                    {
	                                        item.changeType === "CONTACT_CREATED" && <>
	                                            {
	                                                item.changes?.note && <div className="changes-details">
	                                            <span className="mr-2">
	                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
	                                                     xmlns="http://www.w3.org/2000/svg">
	                                                    <rect width="32" height="32" rx="8" fill="#FF1938"
	                                                          fillOpacity="0.16"/>
	                                                    <path
	                                                        fill="transparent"
	                                                        d="M13.0007 9.33325C10.7915 9.33325 9.00065 11.1241 9.00065 13.3333V15.9999C9.00065 16.1602 9.01007 16.3182 9.02839 16.4735C9.00993 16.5346 9 16.5994 9 16.6666V22.5504C9 23.12 9.66808 23.4273 10.1005 23.0566L13.1049 20.4814C13.4674 20.1707 13.9291 19.9999 14.4065 19.9999H21.0007C23.2098 19.9999 25.0007 18.2091 25.0007 15.9999V13.3333C25.0007 11.1241 23.2098 9.33325 21.0007 9.33325H13.0007Z"
	                                                        stroke="#C239D5" strokeWidth="2"/>
	                                                </svg>
	                                            </span>
	                                                    <span>{item.changes.note.newValue}</span>
	                                                </div>
	                                            }
	                                        </>
	                                    }
	                                    {
	                                        item.changeType === "CONTACT_UPDATED" && <div>
	                                            Test
	                                        </div>
	                                    }
		                            </NavLink>
	                            )
                            })
                        :

							contactsHistoryLogs.message
							?
								<p><em>{contactsHistoryLogs.message}</em></p>
							:
								<p><em>No contacts history logs found</em></p>

					:
						<Loader/>
                }
            </div>
        </div>
    )
}

export default ContactsHistoryLogs;
